export function buildErrorReportMessage(failedOperation: string): string {
  return `Wirder failed while ${failedOperation}.`;
}
